export default __webpack_public_path__ + "static/media/logo-x.25438df5.svg";